import React, { useEffect, useState } from 'react';
import { apiFetch, photoUrl } from '../services/apiClient';

// Read-only strip of a project's workflow (job) photos — the pictures added on
// the drilling card show up here on the project pages (office + field). Renders
// nothing until it has at least one photo, so it stays out of the way otherwise.
export default function WorkflowPhotos({ projectId, title = 'Field Photos' }) {
  const [photos, setPhotos] = useState([]);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    if (!projectId) return;
    apiFetch(`/projects/${projectId}/workflow-photos`)
      .then(rows => setPhotos(Array.isArray(rows) ? rows : []))
      .catch(() => {});
  }, [projectId]);

  if (!photos.length) return null;

  return (
    <div style={{ background: '#fff', border: '1px solid #eef0f2', borderRadius: 12, padding: 16, marginBottom: 16 }}>
      <div style={{ fontSize: 12, fontWeight: 800, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.4, marginBottom: 10 }}>
        📷 {title} <span style={{ color: '#9ca3af' }}>· {photos.length}</span>
      </div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {photos.map(p => (
          <img key={p.id} src={photoUrl(p.filename)} alt={p.sub_job_name || 'job photo'}
            onClick={() => setLightbox(photoUrl(p.filename))}
            style={{ width: 96, height: 96, objectFit: 'cover', borderRadius: 8, border: '1px solid #e5e7eb', cursor: 'pointer' }} />
        ))}
      </div>
      {lightbox && (
        <div onClick={() => setLightbox(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 6000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <img src={lightbox} alt="job" style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: 8 }} />
        </div>
      )}
    </div>
  );
}
